document.addEventListener("DOMContentLoaded", function () {
  // ✅ Only run this script on collection pages
  if (!window.location.pathname.includes('/collections/')) return;

  console.log("✅ filter-search.js loaded on collection page");

  let lastFilterIndex = null;

  function addSearchToFilters() {
    const allGroups = document.querySelectorAll(".sidebarBlock.js-filter");

    allGroups.forEach(function (group, index) {
      const ul = group.querySelector("ul.facets__list, ul[data-filter-group]");
      if (!ul || group.querySelector(".custom-filter-search")) return;

      const input = document.createElement("input");
      input.type = "text";
      input.placeholder = "Search options…";
      input.className = "custom-filter-search";
      input.setAttribute("autocomplete", "off");
      input.style.cssText =
        "margin-bottom:10px; padding:6px; width:100%; box-sizing:border-box; border:1px solid #ccc; border-radius:5px;";

      ul.parentNode.insertBefore(input, ul);

      ["keydown", "keypress", "keyup"].forEach(eventType => {
        input.addEventListener(eventType, function (e) {
          e.stopPropagation();
        });
      });

      input.addEventListener("input", function () {
        const searchVal = input.value.toLowerCase().trim();
        let anyVisible = false;

        ul.querySelectorAll("li").forEach(function (li) {
          const label = li.innerText.toLowerCase().trim();
          const match = label.includes(searchVal);
          li.style.display = match ? "" : "none";
          if (match) anyVisible = true;
        });

        const oldMsg = group.querySelector(".no-filter-match-msg");
        if (oldMsg) oldMsg.remove();

        if (!anyVisible && searchVal !== "") {
          const msg = document.createElement("div");
          msg.className = "no-filter-match-msg";
          msg.textContent = "No results found.";
          msg.style.cssText = "padding: 8px 0; color: #888; font-style: italic;";
          ul.parentNode.appendChild(msg);
        }

        lastFilterIndex = index;
      });

      ul.querySelectorAll("input[type='checkbox']").forEach(checkbox => {
        checkbox.addEventListener("click", () => {
          input.blur();
        });
      });
    });

    if (lastFilterIndex !== null) {
      const targetGroup = allGroups[lastFilterIndex];
      if (targetGroup) {
        targetGroup.classList.add("open");

        let retries = 0;
        const tryFocus = setInterval(() => {
          const input = targetGroup.querySelector(".custom-filter-search");
          if (input && input.offsetParent !== null) {
            input.focus();
            clearInterval(tryFocus);
          }
          if (++retries > 10) clearInterval(tryFocus);
        }, 100);
      }
    }

    bindFilterAccordion();
  }

  function handleFilterClick(e) {
    const block = e.currentTarget.closest(".sidebarBlock");

    if (block.classList.contains("open")) {
      block.classList.remove("open");
    } else {
      document.querySelectorAll(".sidebarBlock.open").forEach(openBlock => {
        openBlock.classList.remove("open");
      });
      block.classList.add("open");

      setTimeout(() => {
        const input = block.querySelector(".custom-filter-search");
        if (input) input.focus();
      }, 100);
    }
  }

  function bindFilterAccordion() {
    document.querySelectorAll(".sidebarBlock-heading").forEach(heading => {
      heading.removeEventListener("click", handleFilterClick);
      heading.addEventListener("click", handleFilterClick);
    });
  }

  setTimeout(() => {
    addSearchToFilters();
    bindFilterAccordion();
  }, 1200);

  document.addEventListener("shopify:section:load", () => {
    setTimeout(() => {
      addSearchToFilters();
      bindFilterAccordion();
    }, 150);
  });

  const observer = new MutationObserver(() => {
    setTimeout(() => {
      addSearchToFilters();
      bindFilterAccordion();
    }, 200);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function disableSidebarHoverJS() {
    document.querySelectorAll(".sidebarBlock").forEach(block => {
      block.onmouseenter = null;
      block.onmouseover = null;
    });
  }

  disableSidebarHoverJS();

  document.addEventListener("shopify:section:load", () => {
    setTimeout(() => {
      disableSidebarHoverJS();
    }, 300);
  });
});

